import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { ensureCoupleFromAccount, getUserId, setCoupleCode } from "../../utils/coupleSession";

export const LEGAL_NOTE =
  "本功能仅供娱乐、体验和纪念，不具有任何法律效力，不等同于正式婚姻登记。正式婚姻登记只能由依法具有登记权限的机构办理。";

const LINKS = [
  { to: "/marriage", label: "领证中心", end: true },
  { to: "/marriage/policy", label: "我要领证" },
  { to: "/marriage/places", label: "附近领证" },
  { to: "/marriage/assistant", label: "AI助手" },
  { to: "/marriage/simulation", label: "模拟领证" },
  { to: "/marriage/married-life", label: "婚后模拟" },
  { to: "/marriage/questions", label: "婚前问答" },
  { to: "/marriage/date", label: "领证日" },
  { to: "/travel/love", label: "爱情旅行" },
];

export function Disclaimer({ className = "" }) {
  return (
    <p className={`text-xs text-amber-800 bg-amber-50 border border-amber-100 rounded-xl px-3 py-2 ${className}`}>
      {LEGAL_NOTE}
    </p>
  );
}

export default function MarriageLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-amber-50 flex flex-col">
      <Header />
      <div className="bg-white/80 border-b border-rose-100">
        <div className="max-w-6xl mx-auto px-4 py-2 flex gap-3 overflow-x-auto text-sm">
          {LINKS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap px-3 py-1.5 rounded-full ${
                  isActive ? "bg-rose-500 text-white" : "text-gray-600 hover:bg-rose-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-8">
        <Outlet />
        <p className="mt-10 text-center text-xs text-gray-300">
          <Link to="/wedding" className="hover:text-gray-400">
            婚礼服务
          </Link>
        </p>
      </main>
      <Footer />
    </div>
  );
}

export function CoupleCodeBar({ code, onChange, required = true }) {
  const [hint, setHint] = useState("");
  const [busy, setBusy] = useState(false);
  const loggedIn = Boolean(getUserId());

  const persist = (value) => {
    onChange(setCoupleCode(value));
  };

  const createFromAccount = async () => {
    setBusy(true);
    setHint("");
    try {
      const data = await ensureCoupleFromAccount();
      persist(data.code);
      setHint(
        `已用当前账号生成纪念码 ${data.code}（${data.male_name} & ${data.female_name}）。把这串码发给另一半，婚前问答和婚后模拟就能共用。`
      );
    } catch (err) {
      setHint(err.message || "创建失败");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-4 space-y-2 mb-4 border border-rose-100">
      <p className="text-sm text-gray-600">
        {required
          ? "婚前问答、婚后模拟必须用同一对情侣纪念码。可在「模拟领证」填写双方昵称创建，或登录后用网站资料一键生成，再把码发给另一半。"
          : "领证日按你的网站账号保存，纪念码可选用。登录后即可倒计时，不必先创建纪念码。"}
      </p>
      <div className="flex flex-wrap gap-2 items-center text-sm">
        <span className="text-gray-500">情侣纪念码</span>
        <input
          value={code}
          onChange={(e) => persist(e.target.value)}
          placeholder="LOVE-XXXXXX"
          className="border rounded-xl px-3 py-1.5 w-44"
        />
        <Link to="/marriage/simulation" className="text-rose-600">
          去模拟领证创建
        </Link>
        <button
          type="button"
          disabled={busy}
          onClick={createFromAccount}
          className="px-3 py-1.5 rounded-full border text-rose-600"
        >
          {busy ? "生成中..." : loggedIn ? "用我的账号创建" : "登录后用账号创建"}
        </button>
      </div>
      {hint ? <p className="text-xs text-rose-700">{hint}</p> : null}
    </div>
  );
}
